import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";

// One value of a details grid, its label above it. `span` widens it for long values:
// 2 columns for identifiers, "all" for URLs, lists and previews.
const DetailItem = ({ label, span, children }: { label: ReactNode; span?: 2 | "all"; children: ReactNode }) => (
  <Box sx={{ minWidth: 0, gridColumn: span === "all" ? "1 / -1" : span ? `span ${span}` : undefined }}>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
      {label}
    </Typography>
    <Box
      sx={{
        fontWeight: 600,
        fontSize: 14,
        overflowWrap: "anywhere",
        // An empty react-admin field renders an empty span: show a dash instead of a blank.
        "& .MuiTypography-root:empty::after": { content: '"—"', color: "text.disabled", fontWeight: 400 },
      }}
    >
      {children}
    </Box>
  </Box>
);

export default DetailItem;
